import Axios from "axios";
import token from "./setToken";

export default {
  async getData(id) {
    try {
      const res = await Axios.get("/api/MlitData/" + id, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("国交省登録情報を取得できません[getData]");
      throw error;
    }
  },

  async search(searchCondition) {
    let params = new URLSearchParams();
    params.append('searchCondition', JSON.stringify(searchCondition));

    try {
      const res = await Axios.post("/api/MlitDataList", params, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("国交省登録情報一覧を取得できません[search]");
      throw error;
    }
  },

  async inputDataList() {
    let params = new URLSearchParams();

    try {
      const res = await Axios.post("/api/MlitDataInputDateList", params, token.setTokenToHeader());
      return res;
    } catch (error) {
      console.error("国交省登録情報作成時点一覧を取得できません[search]");
      throw error;
    }
  },
};
